import React from 'react';
export function RotateCounterClockwise({
  height = 24,
  width = 24
}: {
  height?: number;
  width?: number;
}) {
  return <svg width={`${height}px`} height={`${width}px`} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
      <g id="Layer_2" data-name="Layer 2">
        <g id="invisible_box" data-name="invisible box">
          <rect width="48" height="48" fill="none" />
        </g>
        <g id="icons_Q2" data-name="icons Q2">
          <g>
            <path d="M5.7,2A2,2,0,0,1,8,4V8.9A22,22,0,0,1,46,24h0a2,2,0,0,1-4,0h0A18,18,0,0,0,10.6,12h5.3A2.1,2.1,0,0,1,18,13.7,2,2,0,0,1,16,16H6a2,2,0,0,1-2-2V4.1A2.1,2.1,0,0,1,5.7,2Z" />
            <path d="M24,42h0a2,2,0,1,1-2,2A2,2,0,0,1,24,42Z" />
            <path d="M33,39.6h0a1.9,1.9,0,0,1,2.7.7A1.9,1.9,0,0,1,35,43a2,2,0,0,1-2-3.4Z" />
            <path d="M39.6,33a1.9,1.9,0,0,1,2.7-.7,2,2,0,0,1,.8,2.7,2.1,2.1,0,0,1-2.8.7,1.9,1.9,0,0,1-.7-2.7Z" />
            <path d="M5.7,32.3a1.9,1.9,0,0,1,2.7.7h0a1.9,1.9,0,0,1-.7,2.7A1.9,1.9,0,0,1,5,35,1.9,1.9,0,0,1,5.7,32.3Z" />
            <path d="M15,39.6h0a1.9,1.9,0,0,1,.7,2.7,2,2,0,0,1-2.7.8,2.1,2.1,0,0,1-.7-2.8A1.9,1.9,0,0,1,15,39.6Z" />
          </g>
        </g>
      </g>
    </svg>;
}